// ref: https://every-layout.dev/layouts/cluster/
import styled from 'styled-components'
import { mapBreakpoints } from 'etymos'

const attrs = p => ({
	xs: 1,
	justify: 'flex-start',
	align: 'flex-start',
	wrap: 'wrap',
	...p,
})

const Cluster = styled.div.attrs(attrs)`
	display: flex;
	flex-wrap: ${p => p.wrap};
	justify-content: ${p => p.justify};
	align-items: ${p => p.align};
	${mapBreakpoints(v => `margin: -${v / 2}rem;`)}
	& > * {
		${mapBreakpoints(v => `margin: ${v / 2}rem;`)}
	}
`

export default Cluster
